export default function IosThunderstormOutline() {
  return (
    <div
      className="ion-icon-ios-thunderstorm-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<polygon class="st0" points="312,272 272,272 288,224 216,224 201,304 253.3,304 224,400 	"/>
	<g>
		<path class="st0" d="M328.4,172.7c-2.7,0-5.4,0-8,0.3c-7.9-35-39.1-61.4-76.4-61.4c-43.3,0-78.3,35.2-78.3,78.5
			c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.7-47.1,52.8c0,28.6,23.2,53.3,51.7,53.3H182v-17h-11.3c-9.5,0-18.5-4.1-25.4-11
			c-6.8-7-10.6-16.3-10.6-26c0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.3,14.2-1.8c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5
			c0-34.6,28.1-62.7,62.6-62.7c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4
			c26.9,0,48.8,22.3,48.8,49.4c0,27.1-21.9,49.4-48.8,49.4H320v17h8.4c35.7,0,64.6-30.1,64.6-65.9
			C393,202.4,364.1,172.7,328.4,172.7z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
